var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8",
    "data-name": "Group 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.779,
    height: 19.013,
    viewBox: "0 0 23.779 19.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M47.779,206.893c-.307.3-.615.6-.919.907-.249.248-.493.5-.742.755a14.449,14.449,0,0,0-20.447-.025L24,206.859c.232-.218.464-.462.723-.672.571-.463,1.138-.935,1.739-1.355a15.708,15.708,0,0,1,3.447-1.805,16.771,16.771,0,0,1,6.326-1.092A16.606,16.606,0,0,1,43.959,204a16.835,16.835,0,0,1,3.344,2.42l.476.445Z",
    transform: "translate(-24 -201.932)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M44.426,210.227l-1.67,1.66a9.714,9.714,0,0,0-13.748,0l-1.668-1.659A12.024,12.024,0,0,1,44.426,210.227Z",
    transform: "translate(-24 -201.932)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M30.7,213.553a7.3,7.3,0,0,1,10.367.011l-1.677,1.661a4.968,4.968,0,0,0-7.024,0Z",
    transform: "translate(-24 -201.932)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M35.7,220.7a4.125,4.125,0,0,1-.415-.1,1.82,1.82,0,0,1-1.25-1.432,1.8,1.8,0,0,1,.725-1.887c.464-.349,4.25-7.537,6.106-11.1a.21.21,0,0,1,.387.156c-1.155,3.884-3.489,11.805-3.461,12.349a1.874,1.874,0,0,1-1.524,1.975l-.176.038Z",
    transform: "translate(-24 -201.932)",
    fill: "#fff",
    stroke: "#113252",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotSelect);
export default __webpack_public_path__ + "static/media/iotSelect.4b836d7d0e1d777f167475f4a6da7491.svg";
export { ForwardRef as ReactComponent };